export default "__VITE_ASSET__551184d3__"